import { render, staticRenderFns } from "./RunQueryDetailComponent.vue?vue&type=template&id=df60bf6c&scoped=true&"
import script from "./RunQueryDetailComponent.vue?vue&type=script&lang=js&"
export * from "./RunQueryDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./RunQueryDetailComponent.vue?vue&type=style&index=0&id=df60bf6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df60bf6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardText,VCol,VRow,VSelect,VTextField,VTooltip})
